// General
export const APP_NAME = process.env.REACT_APP_APP_NAME;

// Urls
export const AUTH_URL = process.env.REACT_APP_AUTH_URL;
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;